import { getDataAnalyticsService } from '@webapp-next/lib/tracking/get-data-analytics';

const analyticsService = getDataAnalyticsService();

export enum EVENT_NAME {
  PAYROLL_CREATE_STARTED = 'PAYROLL_CREATE_STARTED',
  PAYROLL_ABN_SEARCH_REQUESTED = 'PAYROLL_ABN_SEARCH_REQUESTED',
  PAYROLL_ABN_SEARCH_SUCCESS_ACKNOWLEDGED = 'PAYROLL_ABN_SEARCH_SUCCESS_ACKNOWLEDGED',
  PAYROLL_ABN_SEARCH_FAILURE_ACKNOWLEDGED = 'PAYROLL_ABN_SEARCH_FAILURE_ACKNOWLEDGED',
  PAYROLL_EXTERNAL_PROVIDER_CREATE_REQUESTED = 'PAYROLL_EXTERNAL_PROVIDER_CREATE_REQUESTED',
  PAYROLL_EXTERNAL_PROVIDER_CREATE_SUCCESS_ACKNOWLEDGED = 'PAYROLL_EXTERNAL_PROVIDER_CREATE_SUCCESS_ACKNOWLEDGED',
  PAYROLL_EXTERNAL_PROVIDER_CREATE_FAILURE_ACKNOWLEDGED = 'PAYROLL_EXTERNAL_PROVIDER_CREATE_FAILURE_ACKNOWLEDGED',
  PAY_CALENDAR_CREATE_REQUESTED = 'PAY_CALENDAR_CREATE_REQUESTED',
  PAY_CALENDAR_CREATE_SUCCESS_ACKNOWLEDGED = 'PAY_CALENDAR_CREATE_SUCCESS_ACKNOWLEDGED',
  PAY_CALENDAR_CREATE_FAILURE_ACKNOWLEDGED = 'PAY_CALENDAR_CREATE_FAILURE_ACKNOWLEDGED',
  BUSINESS_ENTITY_CREATE_REQUESTED = 'BUSINESS_ENTITY_CREATE_REQUESTED',
  BUSINESS_ENTITY_CREATE_SUCCESS_ACKNOWLEDGED = 'BUSINESS_ENTITY_CREATE_SUCCESS_ACKNOWLEDGED',
  BUSINESS_ENTITY_CREATE_FAILURE_ACKNOWLEDGED = 'BUSINESS_ENTITY_CREATE_FAILURE_ACKNOWLEDGED',
  PAYSLIP_VIEW_OPENED = 'PAYSLIP_VIEW_OPENED',
  EMPLOYEE_SENTIMENT_CREATE_REQUESTED = 'EMPLOYEE_SENTIMENT_CREATE_REQUESTED',
  EMPLOYEE_SENTIMENT_CREATE_SUCCESS_ACKNOWLEDGED = 'EMPLOYEE_SENTIMENT_CREATE_SUCCESS_ACKNOWLEDGED',
  EMPLOYEE_SENTIMENT_CREATE_FAILURE_ACKNOWLEDGED = 'EMPLOYEE_SENTIMENT_CREATE_FAILURE_ACKNOWLEDGED',
  EMPLOYEE_SENTIMENT_UPDATE_REQUESTED = 'EMPLOYEE_SENTIMENT_UPDATE_REQUESTED',
  EMPLOYEE_SENTIMENT_UPDATE_SUCCESS_ACKNOWLEDGED = 'EMPLOYEE_SENTIMENT_UPDATE_SUCCESS_ACKNOWLEDGED',
  EMPLOYEE_SENTIMENT_UPDATE_FAILURE_ACKNOWLEDGED = 'EMPLOYEE_SENTIMENT_UPDATE_FAILURE_ACKNOWLEDGED',
}

export enum EVENT_SCREEN {
  PAYROLL_SIGNUP = 'PAYROLL_SIGNUP',
  PAY_CALENDAR = 'PAY_CALENDAR',
  BUSINESS_ENTITY = 'BUSINESS_ENTITY',
  PEOPLE = 'PEOPLE',
}

export enum EVENT_SOURCE {
  PAYROLL_SIGNUP_STARTED = 'Payroll Signup Started',
  PAYROLL_ABN_SEARCH = 'Payroll ABN Search',
  PAYROLL_ABN_SEARCH_SUCCESS = 'Payroll ABN Search Success',
  PAYROLL_ABN_SEARCH_FAILURE = 'Payroll ABN Search Failure',
  PAYROLL_EXTERNAL_ACCOUNT_REQUESTED = 'Payroll External Account Requested',
  PAYROLL_EXTERNAL_ACCOUNT_CREATED = 'Payroll External Account Created',
  PAYROLL_EXTERNAL_ACCOUNT_FAILED = 'Payroll External Account Failed To Create',
  CREATE_PAY_CALENDAR = 'Create Pay Calendar',
  CREATE_PAY_CALENDAR_EDIT = 'Create Pay Calendar - Edit',
  CREATE_BUSINESS_ENTITY = 'Create Business Entity',
  CREATE_BUSINESS_ENTITY_EDIT = 'Create Business Entity - Edit',
  OPEN_PAYSLIP = 'Open Payslip',
  SET_EMPLOYEE_SENTIMENT = 'Set Employee Sentiment',
  SET_EMPLOYEE_SENTIMENT_EDIT = 'Set Employee Sentiment - Editing',
}

export enum PROTO {
  BUSINESS_ENTITY = 'business_entity',
  EMPLOYEE_SENTIMENT = 'employee_sentiment',
  PAY_CALENDAR = 'pay_calendar',
  PAYROLL = 'payroll',
  PAYSLIP = 'payslip',
}

export function trackAnalyticsEvent({
  name,
  screen,
  source,
  proto,
  details,
}: {
  name: string;
  screen: string;
  source: string;
  proto?: PROTO;
  details?: Record<string, any>;
}): void {
  analyticsService.track(
    {
      name,
      screen,
    },
    {
      source,
      ...(proto ? { [proto.toString()]: { details } } : {}),
    }
  );
}

export default {
  trackAnalyticsEvent,
  EVENT_NAME,
  EVENT_SCREEN,
  EVENT_SOURCE,
  PROTO,
};
